import React from "react";
import "./styles/style.css";

const Mailto = ({ email, subject, body, children }) => {
  return (
    <a href={`mailto:${email}?subject=${encodeURIComponent(subject) || ''}&body=${encodeURIComponent(body) || ''}`}>{children}</a>
  );
};

function index() {
  return (
    <div className="hero">
      <div className="taglineBox">
        <div className="taglineBox__rotatedText">
          <p>ADS MADE</p>
        </div>
        <div className="taglineBox__remainingText">
          <p>EASY</p>
          <p>EFFECTIVE</p>
          <p>EFFORTLESS</p>
        </div>
      </div>
      <div className="trynowBtn">
        {/* <Mailto email="info.adgpt@gmail.com" subject="Hello AdGPT!" body="Hi, I would like to know more about AdGPT! <Introduce yourself to us>"> */}
          <a href="https://forms.gle/Ue87Yw1qGqVfGxwU7"> <button className="trynowBtn__button" >Sign Up for a Trial!</button> </a>
        {/* </Mailto> */}
      </div>
    </div>
  );
}

export default index;
